import { render } from "./InformRmmModal.vue?vue&type=template&id=160ba5b4"
import script from "./InformRmmModal.vue?vue&type=script&lang=js"
export * from "./InformRmmModal.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_6e4c079c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__